<template>
  <h1
    :class="
      variant === 'large'
        ? 'text-2xl font-semibold'
        : variant === 'medium'
          ? ' text-lg font-semibold'
          : variant === 'medium' ? 'text-sm font-semibold' : ''
    "
  >
    <slot></slot>
  </h1>
</template>
<script>
export default {
  name: 'Title',
  props: {
    variant: {
      type: String,
      required: true,
    },
  },
};
</script>
